export enum OnboardingStepEnum {
  Mode = 'Mode',
  Basic = 'Basic',
  Languages = 'Languages',
  Experience = 'Experience',
  Skill = 'Skill',
  SkillLevel = 'SkillLevel',
  Education = 'Education',
}
